<template>
	<div class="filter-item">
		<span class="filter-name">{{ item.name }}</span>

		<HoverInfo v-if="item.description" :text="item.description"/>

		<RadioSelect :values="item.values" :name="item.id" v-model="vmodel"/>
	</div>
</template>

<script>
	import HoverInfo from "../../common/HoverInfo";
	import RadioSelect from "../../common/RadioSelect";

	export default {
		name: "FilterItem",
		components: {
			HoverInfo,
			RadioSelect
		},
		props: [
			"item",
			"value"
		],
		computed: {
			vmodel: {
				get() {
					return this.value;
				},

				set(value) {
					this.$emit("input", this.item.id, value);
				}
			}
		}
	}
</script>
